/*
 * @@Description: 垂直滚动
 * @@Author: MuYang
 * @Date: 2021-08-09 17:26:56
 * @LastEditTime: 2021-10-14 14:02:34
 */
import ScrollBar from './bar'
import './scroll.scss'
/* 水平滚动 */
export default {
  name: 'scroll',
  props: {
    height: {
      type: [Number],
      default: 0
    },
    type: {
      type: String,
      default: 'all'
    }
  },
  methods: {
    handleScroll (event) {
      this.$emit('scroll', event)
    },
    createScroll () {
      const { width } = this.$el.getBoundingClientRect()
      const scrollWidth = this.$el?.scrollWidth
      if (scrollWidth > width) {
        if (this.scrollBar) { return }
        this.scrollBar = new ScrollBar(this.$el, {
          onScroll: this.handleScroll,
          type: 'horizontal'
        })
      } else {
        this.scrollBar && this.scrollBar.destroyed()
        this.scrollBar = null
      }
    }
  },
  render (h) {
    let style = {}
    if (this.height > 0) {
      style.height = this.height + 'px'
    }
    return <div class={`sy-scroll sy-scroll-${this.type}`} style={style} on-scroll={this.handleScroll}>
      {this.$slots.default}
    </div>
  },
  mounted () {
    setTimeout(() => {
      this.createScroll()
    }, 0)
  },
  updated () {
    this.createScroll()
  },
  destroyed () {
    this.scrollBar && this.scrollBar.destroyed()
  }
}
